import axios from 'axios';
// import useApiServer from '../config/useApiServer';

// const { baseURL: API_BASE_URL } = useApiServer();
// const API_BASE_URL = 'https://devapi.2gathers.com/api/';
// const API_BASE_URL = 'https://testapi.2gathers.com/api/'; //test client server
// const API_BASE_URL = 'https://uatapi.2gathers.com/api/';

// const API_BASE_URL = 'https://devtogetherapi.mindwavetech.com/api/'; //working https dev api
// const API_BASE_URL = 'https://testtogetherapi.mindwavetech.com/api/'; //working https test api
const API_BASE_URL = 'https://liveapi.2gathers.com/api/'; //--client server---

const eventLogoUrl =
  // 'https://devapi.2gathers.com/home/dev2gathers/devapi/togetherfiles'; //dev client server
  // 'https://testapi.2gathers.com/home/test2gathers/testapi/togetherfiles'; //test client server
  // 'https://uatapi.2gathers.com/home/uat2gathers/uatapi/togetherfiles'; //uat client server

// 'https://devtogetherapi.mindwavetech.com/home/devtogether/devtogetherapi/togetherfiles'; //dev server
// 'https://testtogetherapi.mindwavetech.com/home/testtogether/testtogetherapi/timesheetfiles'; //test server
'https://liveapi.2gathers.com/home/live/liveapi/togetherfiles'; // --client server--

class Services {
  create_user(user) {
    return axios.post(API_BASE_URL + 'users/create-user/', user);
  }
  login_api(username, password) {
    return axios.post(
      API_BASE_URL + 'users/login/?email=' + username + '&password=' + password
    );
  }
  list_events() {
    return axios.get(API_BASE_URL + `events/list-events`); //?userId=42
  }
  list_events_controlled(userId) {
    return axios.get(API_BASE_URL + `events/list-events/?userId=${userId}`); //?userId=42
  }
  list_host_events(userId) {
    return axios.get(
      API_BASE_URL + `events/list-events/?userId=${userId}&eventType=HE`
    );
  }
  get_layout() {
    return axios.get(API_BASE_URL + `events/view-layouts/`);
  }
  create_event(getObj) {
    return axios.post(API_BASE_URL + `events/create-event/`, getObj);
  }
  get_box_details(userId, eventId) {
    return axios.get(
      API_BASE_URL + `seats/choose-box/?userId=${userId}&eventId=${eventId}`
    );
  }
  reserve_box(createArr) {
    return axios.post(API_BASE_URL + `seats/reserve-box/`, createArr);
  }
  seat_Info(eventId, boxId) {
    return axios.get(
      API_BASE_URL + `seats/seat-info/?eventId=${eventId}&boxId=${boxId}`
    );
  }
  add_participants(details) {
    return axios.post(API_BASE_URL + 'users/add-participants/', details);
  }
  twilio_service(username, roomName, chatSID, participantName) {
    if (chatSID) {
      return axios.get(
        API_BASE_URL +
          `video/auth/?userId=${username}&room_name=${roomName}&boxChatChannelSID=${chatSID}&participantName=${participantName}`
      );
    } else {
      return axios.get(
        API_BASE_URL +
          `video/auth/?userId=${username}&room_name=${roomName}&participantName=${participantName}`
      );
    }
  }
  twilio_video_service(username, roomName, chatSID, participantName) {
    return axios.get(
      API_BASE_URL +
        `video/auth_new/?userId=${username}&room_name=${roomName}&boxChatChannelSID=${chatSID}&participantName=${participantName}`
    );
  }
  twilio_global_chat_service(username, chatSID, participantName) {
    return axios.get(
      API_BASE_URL +
        `video/room-chat/?userId=${username}&globalChatSID=${chatSID}&participantName=${participantName}`
    );
  }
  twilio_only_box_text_chat_service(username, chatSID, participantName) {
    return axios.get(
      API_BASE_URL +
        `video/box-chat/?userId=${username}&boxChatChannelSID=${chatSID}&participantName=${participantName}`
    );
  }
  forget_password_api(email) {
    return axios.get(API_BASE_URL + 'users/forget-password/?email=' + email);
  }
  change_password(email, currentPassword, newPassword) {
    return axios.get(
      API_BASE_URL +
        'users/change-password/?email=' +
        email +
        '&currentPassword=' +
        currentPassword +
        '&newPassword=' +
        newPassword
    );
  }
  event_logo_URL() {
    return eventLogoUrl;
  }
  box_owner_for(userId, eventId) {
    return axios.get(
      API_BASE_URL + `events/assign-boxes/?userId=${userId}&eventId=${eventId}`
    );
  }
  box_moving(movingDetails) {
    return axios.post(API_BASE_URL + 'seats/box-moving/', movingDetails);
  }
  box_moving_seatAssign(movingFinData) {
    return axios.post(
      API_BASE_URL + 'seats/box-moving-seatassign_new/',
      movingFinData
    );
  }
  layout_coords(layoutId) {
    return axios.get(API_BASE_URL + `events/get-layout/?layoutId=${layoutId}`);
  }
  list_of_invitees(userId, eventId) {
    return axios.get(
      API_BASE_URL + `users/view-users/?userId=${userId}&eventId=${eventId}`
    );
  }
  check_is_email_has_seat(emailId, eventId, boxId) {
    return axios.get(
      API_BASE_URL +
        `users/participants-email-validation/?email=${emailId}&eventId=${eventId}`
    );
  }
  check_is_user(emailId) {
    return axios.get(API_BASE_URL + `users/email-validation/?email=${emailId}`);
  }
  view_user(userId) {
    return axios.get(API_BASE_URL + `users/view-user/?userId=${userId}`);
    // return axios.get(API_BASE_URL + `users/view-user/${userId}/`);
  }
  update_user(userId, updatedData) {
    return axios.put(API_BASE_URL + `users/edit-user/${userId}/`, updatedData);
  }
  get_event(eventId, eventUniqueNo) {
    return axios.get(API_BASE_URL + `events/view-event/${eventId}`);
  }
  get_event_new(eventId, eventUniqueNo) {
    return axios.get(
      API_BASE_URL +
        `events/view-event_new/?eventId=${eventId}&eventUniqueNo=${eventUniqueNo}`
    );
  }
  edit_event(eventId, getObj) {
    return axios.put(API_BASE_URL + `events/edit-event/${eventId}/`, getObj);
  }
  update_event_status(status, eventId) {
    return axios.get(
      API_BASE_URL +
        `events/event-status/?eventStatus=${status}&eventId=${eventId}`
    );
  }
  exit_event(userId, eventId) {
    return axios.get(
      API_BASE_URL + `seats/exit_event/?userId=${userId}&eventId=${eventId}`
    );
  }
  single_event_details(userId, eventId, eventUniqueNo) {
    return axios.get(
      API_BASE_URL +
        `events/list-event_details/?userId=${userId}&eventId=${eventId}&eventUniqueNo=${eventUniqueNo}`
    );
  }
  list_users(userId) {
    return axios.get(API_BASE_URL + `users/get_users_list/userId=${userId}`);
  }
  change_role(changeRoleReq) {
    return axios.post(API_BASE_URL + `users/update_user_type/`, changeRoleReq);
  }
  create_transaction(reqObj) {
    return axios.post(API_BASE_URL + `payments/create_transaction/`, reqObj);
  }
  logout(userId) {
    return axios.get(API_BASE_URL + `users/logout/?userId=${userId}`);
  }
  unsubscribe_mails(userId) {
    return axios.get(API_BASE_URL + `users/unsubscribe/?userId=${userId}`);
  }
  send_otp_login(phoneNum) {
    return axios.get(
      API_BASE_URL + `users/sentotp_tologin/?phoneNumber=${phoneNum}`
    );
  }
  verify_otp_login(loginReq) {
    return axios.post(API_BASE_URL + `users/verifyotp_tologin/`, loginReq);
  }

  GetUsers() {
    return axios.get(API_BASE_URL + `users/get_users_list/`);
  }
  create_emailList(emailList) {
    return axios.post(API_BASE_URL + 'users/users_add/', emailList);
  }
  delete_event(eventId) {
    return axios.delete(API_BASE_URL + `events/delete-event/${eventId}/`);
  }

  passcode_email_check(email, eventId) {
    return axios.get(
      API_BASE_URL + `users/email-check/?email=${email}&eventId=${eventId}`
    );
  }
  shared_event_call(guestRequest) {
    //watch event as guest api
    return axios.post(API_BASE_URL + `events/share-event/`, guestRequest);
  }
  update_password(pass, email, CPass) {
    //used in forgot password link
    return axios.get(
      API_BASE_URL +
        `users/update-password/?password=${pass}&email=${email}&confirmpassword=${CPass}`
    );
  }
  emailVerify(userId) {
    return axios.get(API_BASE_URL + `users/user-verify/?userId=${userId}`);
  }
  tokenRefresh(refreshToken) {
    return axios.post(API_BASE_URL + `users/refresh/`, {
      refresh: refreshToken,
    });
  }
}

export default new Services();

// https://devtogetherapi.mindwavetech.com/api/users/sentotp_tologin/?phoneNumber=919182675262

// method: GET

// response:

// {
//     "responseCode": 200,
//     "message": "Otp sent successfully"
// }

// https://devtogetherapi.mindwavetech.com/api/users/verifyotp_tologin/

// methos: POST

// request:

// {
//     "phoneNumber":"919182675262",
//     "otp":"092633"

// }
// response:

// {
//     "responseCode": 200,
//     "accessToken": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ0b2tlbl90eXBlIjoiYWNjZXNzIiwiZXhwIjoxNjMyMzMzNTg3LCJqdGkiOiI5ZDg4NjdmOGQ2ZTg0YTk0ODk2ODlkOGE3YmUzZjhjOCIsInVzZXJfaWQiOjEyN30.D58CIU5jMp9nFJ_QbCdbWl4F0CicXkzwGXNyJGgU6pk",
//     "refreshToken": "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ0b2tlbl90eXBlIjoicmVmcmVzaCIsImV4cCI6MTYzMjkzNzc4NywianRpIjoiNzI1MjYwYzA3NTBkNDI4ZDk1MDliZTg0ODhhN2RiNWIiLCJ1c2VyX2lkIjoxMjd9.93keNC9sFdeX590S6nUU0uSC43EEhLxlW7PHBawaGqk",
//     "userDetails": {
//         "userId": 127,
//         "userType": 3,
//         "firstName": "Vasanthi",
//         "lastName": "Reddy",
//         "firstLogin": true,
//         "email": "vasanthi@castusinfo.com"
//     }
// }
